import Image from "next/image"
import { MainLayout } from "components/Layout"
import { useLang } from "hooks/useLang"
import Button from "components/Form/Button"
import { useRouter } from "next/router"

const Custom404 = () => {
    const { t, isAr } = useLang()
    const { push } = useRouter()

    return (
        <MainLayout>
            <div className={`my-10 flex flex-col gap-10 p-5`}>
                <div className="relative h-[400px] w-full sm:h-[500px]">
                    <Image fill src="/svg/404.svg" alt="404" />
                </div>
                <div className="flex w-full flex-row items-center justify-center">
                    {/* <div className="w-2/6"> */}
                    <Button
                        className="px-10 py-3"
                        size="large"
                        onClick={() => push("/")}
                    >
                        {t("Go_Home")} {isAr ? <>&larr;</> : <>&rarr;</>}
                    </Button>
                    {/* </div> */}
                </div>
            </div>
        </MainLayout>
    )
}

export default Custom404
